/* 孫吳傳・第 15 章：逍遙津（建安二十年，215）
 * 史實：《三國志·張遼傳》張遼「募敢從之士，得八百人」，「被甲持戟，先登陷陣，殺數十人，斬二將，大呼自名」。
 *       《吳主傳》注引《江表傳》：「權乘駿馬上津橋，橋南已見徹，丈餘無版。谷利在馬後，使權持鞍緩控，利於後著鞭，以助馬勢，遂得超度。」
 *       《凌統傳》：凌統率親近三百人斷後，「左右盡死，身亦被創」。
 *       《張遼傳》：圍城之初，「平旦，遼被甲持戟，先登陷陳……衝壘入，至權麾下。權大驚，衆不知所爲，走登高冢，以長戟自守。
 *       遼叱權下戰，權不敢動，望見遼所將衆少，乃聚圍遼數重」；張遼突圍而出。「權守合肥十餘日，城不可拔，乃引退。」
 * 開場（擴充）：平旦張遼衝營 → 孫權登上高冢自守（站在冢上撐 20 秒）→ 吳軍聚圍、張遼突圍而出 → 十餘日後撤軍，接下面。
 * 招式環節：W 長江天塹的深水擋得住張遼的衝鋒——衝鋒的紅線畫出來時，在線上橫著放一道水，張遼衝到水邊就停下、愣住。
 * 流程：孫權從合肥撤軍，被張遼八百人突擊。張遼的衝鋒路線會先畫出紅線，要閃開 → 撤到津橋，凌統在橋頭斷後 →
 *       橋南段已拆、丈餘無版：谷利每隔一陣揮一次鞭，看準揮鞭的瞬間下令往南走，才躍得過去（時機不對馬不肯跳）→ 回到南岸大營。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, hero, TROOPS, rout, vanish } from '../kit.ts';
import { GAP, EDGE, HEAD, SOUTH_SIDE } from '../maps/xiaoyao.ts';

const LV = 13, START = [3200, 1000], CAMP = [3000, 4300], WHIP = 3.2, WINDOW = 0.8;
const SIEGE = [3000, 1350], MOUND = [2300, 1250], FOOT = [2650, 1380], HOLD = 20; // 圍城的吳營、孫權登上的高冢
const FOE = { spec: TROOPS.wei, name: '張遼的敢死士', hp: 520, maxHp: 520, atk: 30, ms: 255 };

export default {
  id: 'sunwu-15', map: 'xiaoyao', hero: 'sunquan',
  title: '第 13 章　逍遙津', year: '建安二十年（215）',
  brief: {
    quote: [{ text: '權乘駿馬上津橋，橋南已見徹，丈餘無版。', src: '《吳主傳》注引《江表傳》' }],
    text: '孫權率十萬之眾圍合肥。守將張遼趁吳軍還沒合圍，連夜招募八百敢死之士，天一亮就殺進吳營。',
    goals: ['平旦：登上高冢自守，撐到吳軍聚圍張遼', '十餘日後撤軍：閃開張遼的衝鋒，撤到津橋', '在谷利揮鞭的瞬間躍過斷橋', '回到南岸大營'],
  },
  words: { ally: '親近', foe: '敢死士' },
  stars: [
    { text: '一次就躍過斷橋', ok: (m) => (m.vars.miss || 0) === 0 },
    { text: '張遼的衝鋒一次也沒撞到孫權', ok: (m) => !m.vars.rammed },
    { text: '用長江天塹擋下張遼的衝鋒', ok: (m) => (m.vars.blocked || 0) > 0 },
  ],
  steps: [
    { // 0. 平旦：張遼衝營，孫權走登高冢
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = SIEGE[0]; me.y = SIEGE[1];
        V.guard = Array.from({ length: 10 }, (_, i) => { const u = m.recruit(me.x - 60 - (i % 4) * 50, me.y - 60 + Math.floor(i / 4) * 90, '親兵'); m.join(u, me); return u; });
        V.zl = boss(w, hero('zhangliao'), 3600, 800, { name: '張遼', hp: 7000, atk: 70, armor: 9, ms: 250, untargetable: false });
        V.zl.home = [me.x, me.y];
        V.sally = Array.from({ length: 10 }, (_, i) => m.foe('huangjin', 3500 + (i % 4) * 80, 700 + Math.floor(i / 4) * 100, Object.assign({}, FOE, { atk: 22 })));
        for (const u of V.sally) u.home = [me.x, me.y];
        V.charging = true; V.chargeT = 4;
        m.card('平旦，遼被甲持戟，先登陷陳，殺數十人，斬二將，大呼自名，衝壘入，至權麾下。', '《張遼傳》');
        m.after(5, () => m.line('孫權', '張遼……殺到這裡來了？！'));
        m.after(7.5, () => m.line('提示', '先上西邊的高冢。張遼衝鋒前地上會畫紅線：閃開，或在線上橫著放 W 長江天塹，深水擋得住他。'));
        m.mark('mound', MOUND[0], MOUND[1], '高冢');
        m.obj('mound', '登上高冢');
      },
      tick(m, w) { return m.near(w.player, MOUND[0], MOUND[1], 150); },
    },
    { // 1. 以長戟自守：張遼叱權下戰，權不敢動
      enter(m, w) {
        const V = m.vars;
        m.done('mound');
        m.card('權大驚，衆不知所爲，走登高冢，以長戟自守。', '《張遼傳》');
        m.after(5, () => m.line('張遼', '孫權！下來與我一戰！'));
        m.after(10, () => m.line('張遼', '十萬之眾，只會躲在冢上嗎？'));
        V.holdT = 0;
        m.obj('hold', '以長戟自守（站在冢上）');
      },
      tick(m, w, dt) {
        const V = m.vars, me = w.player;
        if (m.near(me, MOUND[0], MOUND[1], 170)) V.holdT += dt;
        else if (!V.warnLeave || w.t - V.warnLeave > 8) { V.warnLeave = w.t; m.line('親兵', '主公，回冢上！張遼就等著主公下去！'); }
        m.get('hold').text = `以長戟自守（站在冢上 ${Math.min(HOLD, Math.floor(V.holdT))}/${HOLD} 秒）`;
        return V.holdT >= HOLD;
      },
    },
    { // 2. 聚圍遼數重；張遼突圍。十餘日後，引退
      enter(m, w) {
        const V = m.vars, zl = V.zl;
        m.done('hold'); m.unmark('mound');
        V.charging = false;
        m.card('權不敢動，望見遼所將衆少，乃聚圍遼數重。', '《張遼傳》');
        V.ring = Array.from({ length: 14 }, (_, i) => { const a = (i / 14) * Math.PI * 2, u = m.recruit(zl.x + Math.cos(a) * 260, zl.y + Math.sin(a) * 180, '吳軍'); u.home = [zl.x, zl.y]; return u; });
        m.after(5, () => { zl.untargetable = true; zl.home = [3600, 600]; zl.target = null; m.line('張遼', '隨我殺出去！'); rout(m, w, V.sally.slice(0, 6), [3600, 600]); });
        m.after(8, () => m.line('魏兵', '將軍棄我乎！'));
        m.after(10, () => { zl.home = [zl.x, zl.y]; m.line('張遼', '我回來了！'); });
        m.after(13, () => { rout(m, w, V.sally, [3600, 600]); zl.home = [3600, 600]; m.card('遼復還突圍，拔出餘衆。權人馬皆披靡，無敢當者。', '《張遼傳》'); });
        m.after(19, () => { m.big('十餘日後'); m.card('權守合肥十餘日，城不可拔，乃引退。', '《張遼傳》'); });
        m.after(25, () => { V.next = true; });
      },
      tick(m) { return !!m.vars.next; },
    },
    { // 3. 引退：張遼追擊，撤到津橋
      enter(m, w) {
        const me = w.player, V = m.vars;
        me.x = START[0]; me.y = START[1]; me.hp = me.maxHp; me.mp = me.maxMp; // 十餘日後：傷養好了
        for (const u of (V.sally || []).concat(V.ring || [], [V.zl])) if (u) vanish(w, u);
        for (const u of m.alive(V.guard)) { u.x = me.x - 80; u.y = me.y + (SG.rand() - 0.5) * 120; }
        V.charging = true;
        V.lt = ally(w, 'lingtong', HEAD[0] + 60, HEAD[1] - 120, LV); V.lt.hold = [HEAD[0], HEAD[1] - 100];
        V.qin = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(HEAD[0] - 200 + (i % 4) * 130, HEAD[1] - 220 + Math.floor(i / 4) * 80, '凌統親近'); u.home = [u.x, u.y]; return u; });
        V.zl = boss(w, hero('zhangliao'), 4100, 900, { name: '張遼', hp: 7000, atk: 70, armor: 9, ms: 250, untargetable: false });
        V.zl.home = [me.x, me.y];
        V.foes = Array.from({ length: 22 }, (_, i) => m.foe('huangjin', 5000 + (i % 6) * 80, 800 + Math.floor(i / 6) * 120, FOE));
        for (const u of V.foes) u.home = [me.x, me.y];
        V.chargeT = 2.5;
        m.gate('gap', GAP[0], GAP[1], 120, 'repair', null, { a: Math.PI / 2, w: 190 });
        m.line('張遼', '張文遠在此！孫權休走！');
        m.after(2.5, () => m.line('孫權', '快撤！往津橋去！'));
        m.card('遼率諸軍追擊，幾復獲權。', '《張遼傳》');
        m.mark('bridge', HEAD[0], HEAD[1], '津橋');
        m.obj('bridge', '閃開張遼的衝鋒，撤到津橋');
      },
      tick(m, w) { return m.near(w.player, HEAD[0], HEAD[1], 220); },
    },
    { // 2. 斷橋：看準揮鞭的時機
      enter(m, w) {
        const V = m.vars;
        V.charging = false;
        m.done('bridge'); m.unmark('bridge');
        m.line('凌統', '主公先走！凌統在此斷後！');
        m.after(2.5, () => m.card('權乘駿馬上津橋，橋南已見徹，丈餘無版。', '《江表傳》'));
        m.after(6, () => m.line('提示', '谷利會在馬後揮鞭（橋上閃金光的那一下）。就在那一瞬間右鍵點南岸，馬才躍得過去。'));
        V.gu = m.folk(EDGE[0] + 70, EDGE[1] - 50, { name: '谷利', still: true, near: 1, draw: guli });
        V.whipT = WHIP; V.miss = 0;
        m.mark('edge', EDGE[0], EDGE[1], '斷口');
        m.obj('jump', '在谷利揮鞭的瞬間躍過斷橋');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, I = me.input;
        V.whipT -= dt;
        const open = V.whipT <= 0 && V.whipT > -WINDOW;
        if (V.whipT <= -WINDOW) V.whipT = WHIP;
        V.gu.whip = open;
        if (open && !V.cued) { V.cued = true; m.line('谷利', '著鞭！'); }
        if (!open) V.cued = false;
        // 在斷口北邊、下令往南走
        // 只看「這一下」新下的指令（之前點的還掛著不算），不然先點好就能等著自動跳
        const fresh = I.moveTo && I.moveTo !== V.lastMt; V.lastMt = I.moveTo;
        const atEdge = m.near(me, EDGE[0], EDGE[1], 170), south = fresh && I.moveTo[1] > GAP[1];
        if (atEdge && south) {
          if (open) {
            me.x = SOUTH_SIDE[0]; me.y = SOUTH_SIDE[1]; I.moveTo = null;
            w.fx({ k: 'puff', x: EDGE[0], y: EDGE[1] }); w.fx({ k: 'puff', x: me.x, y: me.y });
            return true;
          }
          V.miss++; m.line('谷利', '還不是時候！主公持鞍緩控——');
        }
        return false;
      },
    },
    { // 3. 遂得超度
      enter(m, w) {
        const V = m.vars;
        m.done('jump'); m.unmark('edge');
        m.big('躍過斷橋！');
        m.card('利於後著鞭，以助馬勢，遂得超度。', '《江表傳》');
        m.mark('camp', CAMP[0], CAMP[1], '南岸大營');
        m.obj('camp', '回到南岸大營');
        m.after(4, () => m.line('凌統', '主公過去了！弟兄們，再撐一下！'));
        V.lt.hold = null;
      },
      tick(m, w) {
        if (!m.near(w.player, CAMP[0], CAMP[1], 300)) return false;
        const V = m.vars;
        m.done('camp');
        rout(m, w, V.foes, [3600, 600]);
        V.zl.home = [3600, 600]; V.zl.target = null; V.zl.untargetable = true;
        if (V.lt.alive) m.card('統率親近三百人陷圍，扶扞權出。……左右盡死，身亦被創。', '《凌統傳》'); else m.line('旁白', '凌統沒能回來。（正史中凌統負傷生還）');
        m.after(6, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  ground(ctx, m, view, inView) { if (inView(MOUND[0], MOUND[1], 200)) mound(ctx, { x: MOUND[0], y: MOUND[1] }); },
  always(m, w, dt) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('孫權陣亡'); return; }
    if (!V.zl) return;
    if (V.lt) allyTick(w, V.lt, null, 450);
    if (V.qin) for (const u of V.qin) if (u.alive && !(u.target && u.target.alive)) u.home = u.home || [u.x, u.y];
    // 敢死士一路追孫權；過了斷橋就追不到了（在橋頭跟凌統打）
    if (V.foes) for (const u of V.foes) if (u.alive && !u.rout && !(u.target && u.target.alive)) u.home = me.y > GAP[1] ? [HEAD[0] + (SG.rand() - 0.5) * 200, HEAD[1] - 150] : [me.x, me.y];
    // 張遼的衝鋒：先畫紅線，1.1 秒後衝過去，線上的人都被撞
    const zl = V.zl;
    if (zl.alive && !zl.untargetable && V.charging) {
      V.chargeT -= dt;
      if (V.chargeT <= 0 && SG.gd(zl.x, zl.y, me.x, me.y) < 1200) {
        V.chargeT = 6;
        const dx = me.x - zl.x, dy = me.y - zl.y, L = Math.hypot(dx, dy) || 1, len = Math.min(900, L + 200), x2 = zl.x + (dx / L) * len, y2 = zl.y + (dy / L) * len;
        const [ex, ey] = SG.MAP.walkable(x2, y2, SG.MAP.BODY) ? [x2, y2] : SG.MAP.nearestFree(x2, y2);
        const x1 = zl.x, y1 = zl.y;
        m.warn({ x1, y1, x2: ex, y2: ey, w: 130, t: 1.1, col: '#ff4030', fn: (hit) => {
          // 長江天塹：衝鋒路線上有孫權的深水，衝到水邊就停下、愣住；水後面的人不會被撞
          const k = waterCut(w, x1, y1, ex, ey);
          const sx = x1 + (ex - x1) * k, sy = y1 + (ey - y1) * k;
          for (const u of hit) if (u.team === 0 && (k >= 1 || SG.gd(u.x, u.y, x1, y1) < SG.gd(sx, sy, x1, y1))) { m.hurt(u, u === me ? (m.i <= 1 ? 110 : 180) : 140, 1, { stagger: 0.4 }); if (u === me) V.rammed = true; }
          zl.x = sx; zl.y = sy; w.fx({ k: 'slam', x: sx, y: sy, r: 160, col: k < 1 ? '#5fc4e8' : '#ff6040' });
          if (k < 1) { V.blocked = (V.blocked || 0) + 1; zl.st.stun = Math.max(zl.st.stun, 1.5); m.line('張遼', '……水？！'); }
        } });
        m.line('張遼', ['張文遠在此！', '孫權小兒，哪裡走！', '八百足矣！'][Math.floor(SG.rand() * 3)]);
      }
      if (m.i <= 1) { zl.target = null; zl.think = 0.5; zl.home = FOOT.slice(); } // 平旦：張遼在冢下叱權下戰，只靠衝鋒
      else if (!(zl.target && zl.target.alive)) zl.home = [me.x, me.y];
    }
    if (m.i <= 1 && V.sally) for (const u of V.sally) {
      if (!u.alive || u.rout) continue;
      if (m.i === 1 && u.target === me) { u.target = null; u.think = 0.5; } // 冢上有長戟護著：敢死士只跟冢下的親兵打
      if (!(u.target && u.target.alive)) u.home = m.i === 1 ? [FOOT[0] + (SG.rand() - 0.5) * 300, FOOT[1] + 60] : [me.x, me.y];
    }
  },
};

// 衝鋒路線（x1,y1 → x2,y2）碰到孫權長江天塹的深水：回傳碰到的比例（沒碰到是 1），停在水邊前一點
function waterCut(w, x1, y1, x2, y2) {
  const cs = (w.sqChannels || []).filter((c) => c.team === 0 && c.until > w.t), K = SG.K;
  if (!cs.length) return 1;
  for (let i = 1; i <= 60; i++) {
    const k = i / 60, x = x1 + (x2 - x1) * k, y = y1 + (y2 - y1) * k;
    for (const c of cs) {
      const dx = x - c.x, dy = (y - c.y) / K, along = dx * c.tx + dy * c.ty, across = -dx * c.ty + dy * c.tx;
      if (Math.abs(along) <= c.half + 20 && Math.abs(across) <= c.thick / 2 + 40) return Math.max(0, k - 2 / 60);
    }
  }
  return 1;
}
// 高冢：一座土丘
function mound(ctx, f) {
  ctx.save(); ctx.translate(f.x, f.y);
  ctx.fillStyle = 'rgba(120,96,60,.55)'; ctx.beginPath(); ctx.ellipse(0, 0, 170, 90, 0, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = 'rgba(150,124,80,.6)'; ctx.beginPath(); ctx.ellipse(0, -10, 110, 56, 0, 0, Math.PI * 2); ctx.fill();
  ctx.restore();
}
// 谷利：站在馬後，揮鞭的那一下鞭梢閃金光
function guli(ctx, f, T) {
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 2, 18, 6, 60, 0.3);
  SG.draw.poly(ctx, [[-10, -20], [10, -20], [9, -48], [-9, -48]], '#7f2a24', 1.8);
  ctx.beginPath(); ctx.arc(0, -58, 9, 0, Math.PI * 2); SG.draw.ink(ctx, '#d8b088', 1.6);
  const a = f.whip ? -0.3 : -1.6;
  ctx.strokeStyle = f.whip ? '#ffd46b' : '#4a3424'; ctx.lineWidth = f.whip ? 4 : 2.5; ctx.beginPath(); ctx.moveTo(8, -40); ctx.quadraticCurveTo(8 + Math.cos(a) * 30, -40 + Math.sin(a) * 30, 8 + Math.cos(a + 0.6) * 60, -40 + Math.sin(a + 0.6) * 60); ctx.stroke();
  if (f.whip) { ctx.fillStyle = 'rgba(255,212,107,.5)'; ctx.beginPath(); ctx.arc(8 + Math.cos(a + 0.6) * 60, -40 + Math.sin(a + 0.6) * 60, 14, 0, Math.PI * 2); ctx.fill(); }
  ctx.restore();
}
